module.exports = __webpack_public_path__ + "static/img/case3.3352191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case3.png
// module id = LpPf
// module chunks = 3